import styled from 'styled-components';

export const ContainerLoginFlowStyle = styled.div`
  background-color: #e8e8e8;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 100%;
  position: absolute;
  overflow: auto;
`;
